module.exports = __webpack_public_path__ + "static/media/code-branch.11ed69b1.svg";